import React, { useState, useEffect } from 'react';

import { format } from 'date-fns';
import api from '../../services/api';

import NavBar from '../../components/NavBar';
import Table from '../../components/Table';
import Loader from '../../components/Loader';
import Error from '../../components/Error';
import Line from '../../components/Line';
import ButtonNew from '../../components/ButtonNew';

import * as S from './styles';
import { led } from '../../utils/led';

const Media = () => {
  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(false);
  const [lstData, setData] = useState([]);
  const objColumns = [
    {
      title: '',
      field: '_medStatus',
      formatter: 'html',
      width: 15,
      align: 'center',
    },
    {
      title: 'F Main',
      field: '_medFeaturedMain',
      formatter: 'html',
      width: 100,
      align: 'center',
    },
    {
      title: 'Featured',
      field: '_medFeatured',
      formatter: 'html',
      width: 110,
      align: 'center',
    },
    {
      title: 'Type',
      field: 'medType',
      headerFilter: 'input',
      width: 110,
      align: 'center',
    },
    { title: 'Title', field: 'medTitle', headerFilter: 'input' },
    { title: 'Categories', field: '_medCategory', headerFilter: 'input' },
    {
      title: 'Created',
      field: '_medDateCreated',
      headerFilterPlaceholder: 'filter',
      headerFilter: 'input',
      align: 'center',
      width: 100,
    },
    {
      title: 'Updated',
      field: '_medDateUpdated',
      headerFilterPlaceholder: 'filter',
      headerFilter: 'input',
      align: 'center',
      width: 100,
    },
  ];

  const auxFormatData = objData => {
    objData.id = objData.medId;
    objData._medStatus = led(objData.medStatus);
    objData._medFeaturedMain = led(objData.medFeaturedMain, true);
    objData._medFeatured = led(objData.medFeatured, true);
    objData._medCategory = objData.medCategory1;
    objData._medCategory += objData.medCategory2 !== ' ' ? ` - ${objData.medCategory2}` : '';
    objData._medCategory += objData.medCategory3 !== ' ' ? ` - ${objData.medCategory3}` : '';
    objData._medDateCreated = format(
      new Date(objData.medDateCreated),
      'MM/dd/yyyy'
    );
    objData._medDateUpdated = format(
      new Date(objData.medDateUpdated),
      'MM/dd/yyyy'
    );
    return objData;
  };

  useEffect(() => {
    async function loadData() {
      const resGetData = await api('GET', '/media', null);
      const {
        data: { resData },
      } = resGetData;

      console.log(resData);
      const tmpData = resData !== null ? resData.map(auxFormatData) : [];
      setData(tmpData);
      setLoading(false);
    }

    try {
      loadData();
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  }, []);

  // propDblClickRedirect="/artist"
  // propDblClickRedirect="undefined"
  const viewData = () => {
    return !isError ? (
      <Table
        propColumns={objColumns}
        propData={lstData}
        propDblClickRedirect="/media"
      />
    ) : (
      <Error />
    );
  };

  return (
    <>
      <NavBar />
      <S.Container>
        <S.ContainerHeader>
          <S.ContainerTitle>
            <S.Title>Medias</S.Title>
            <ButtonNew propLink="/media/new" />
          </S.ContainerTitle>
          <Line />
        </S.ContainerHeader>
        <S.ContainerContent>
          {isLoading ? <Loader /> : viewData()}
        </S.ContainerContent>
      </S.Container>
    </>
  );
};

export default Media;
